export interface SaveHcpcsRequestDTO {
  hcpcsId?: string | null;
  hcpcsCode: string;
  shortDescription: string;
  cmsEffectiveStartDate: string;
  cmsEffectiveEndDate?: string | null;
  productId: string;
  tenantId: string;
  overrideTypeId: string;
  planEffectiveStartDate: string;
  planEffectiveEndDate?: string | null;
  dmeposCategoryId?: string | null;
  hcpcsClinicalForms?: any[];
  hcpcsModifiers?: any[];
}

export interface SaveCodeResponseDTO {
  success: boolean;
  message: string;
  hcpcsId?: string;
  hcpcsByTenantLoBProductId?: string;
  isNewCode?: boolean;
  errors?: string[];
}

export enum SaveHcpcsResult {
  Created = 'Created',
  Updated = 'Updated',
  DuplicateCode = 'DuplicateCode',
  Failed = 'Failed'
}

export interface SaveHcpcsWithAssociationDTO {
  result: SaveHcpcsResult;
  hcpcsId?: string | null;
  associationId?: string | null;
  errorMessage?: string | null;
  hcpcsByCategoryId?: string | null;
  categoryMessage?: string | null;
}
